import { useTypedQuery } from "hooks";
import { ReportTemplatesDashboardQueryKeys } from "modules/ReportTemplatesDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useReportTemplatesListQuery = () =>
  useTypedQuery({
    queryKey: ReportTemplatesDashboardQueryKeys.list,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.get(endpoint, baseUrl)).data.report_templates
  });
